<div class="z-200 flex items-center rounded-t-3xl py-2 border-b-4 border-modules-eclass-500 shadow-md md:p-0">
  <div class="flex min-w-0 flex-1 flex-row items-center gap-1 p-1 md:gap-3 lg:p-0">
    <div class="flex shrink-0 items-center justify-center rounded-tl-3xl bg-base-gray-light-50">
      <svg-icon
        class="lg:mx-5 lg:my-[18px] lg:h-[24px] lg:w-[72px]"
        [src]="'/assets/images/logos/' + ((isExternal$ | async) ? 'logo-weekly.svg' : 'logo-eclass.svg')"
      >
      </svg-icon>
    </div>

    <div class="flex min-w-0 flex-1 items-center justify-between md:gap-4">
      <div class="min-w-0 flex-1 overflow-hidden lg:w-1/2">
        <div class="flex h-full flex-col">
          <div class="flex items-center gap-2">
            <span class="max-h-10 truncate text-base font-semibold leading-tight text-base-gray-500 md:text-lg">
              {{ activityCtrl.value?.title }}
            </span>

            <span class="flex shrink-0 items-center gap-1">
              <svg-icon class="w-3 text-modules-eclass-500 md:w-4" src="assets/icons/icon-user-3.svg"> </svg-icon>

              {{ data.activity.completed }}/{{ data.activity.total }}
            </span>
          </div>

          <span class="truncate text-base font-normal leading-tight text-base-gray-400">
            Limite de entrega: {{ activityCtrl.value?.date_end | date: 'medium' }}
          </span>
        </div>
      </div>

      <!-- Select -->
      <div class="min-w-0 w-1/3 shrink-0">
        <ng-select
          app-select
          [formControl]="activityCtrl"
          [items]="pendingActivities$ | async"
          bindLabel="title"
          [clearable]="false"
          [searchable]="false"
          placeholder="Select"
          [notFoundText]="'Não encontrado'"
          class="group-ng-select-opened:[&>div]:!rounded-none h-full! w-full! pb-0! [&>div]:rounded-full [&>div]:bg-modules-eclass-100!"
        >
        </ng-select>
      </div>
    </div>
  </div>

  <!-- Cerrar -->
  <div class="flex shrink-0 p-2 md:ml-4 md:p-5">
    <button type="button" app-icon-button dialogClose class="p-0!">
      <svg-icon class="h-8 w-8 select-none" src="assets/icons/icon-close-fine.svg"> </svg-icon>
    </button>
  </div>
</div>

<div
  app-modal-content
  [ngClass]="{ 'grid-rows-1!': expand() }"
  class="w-full flex flex-col md:flex-row h-[95vh]! md:h-[90vh]! md:w-[95vw]! min-w-[360px]! overflow-hidden! p-0!"
>
  @if (loading$ | async) {
    <div class="relative flex flex-col h-full w-full md:flex-row">
      @if (students$ | async; as studentFilterState) {
        <!-- lista de alumnos -->
        <div
          [ngClass]="{
            'md:w-3/5 transition-all duration-300': !answer,
            'duration-400 md:w-2/5 transition-all': answer,
            hidden: expand(),
          }"
          class="z-30 flex flex-col md:h-full h-fit justify-center bg-base-gray-light-50 shadow-right"
        >
          <div class="flex md:h-full flex-col">
            <div
              class="flex flex-row h-fit w-full px-4 md:flex-col items-center py-4 justify-around md:justify-center gap-4 md:p-8"
            >
              <div class="flex h-fit md:w-full md:justify-between">
                <span class="md:flex hidden font-goldplay text-lg text-base-gray-light-950" translate
                  >eclass.relatorios.alunos</span
                >
                <div class="flex w-fit items-center gap-2">
                  <button
                    #popoverRight
                    (click)="onFilterStudents(popoverRight)"
                    class="h-10 w-10 rounded-md p-2 shadow-md"
                  >
                    <svg-icon
                      class="text-xs text-modules-eclass-500"
                      [src]="'/assets/icons/icon-filter-question.svg'"
                    ></svg-icon>
                  </button>
                  <span class="font-goldplay text-base text-base-gray-light-950" translate
                    >eclass.relatorios.filtrar</span
                  >
                </div>
              </div>
              <div class="relative w-full md:w-fit flex items-center justify-center">
                <input
                  app-input
                  [formControl]="searchCtrl"
                  class="rounded-l-full rounded-r-full border-none py-3 pl-14 shadow-inner shadow-base-gray-light-700 focus:border-0! focus:ring-modules-eclass-400! xs:w-16 md:w-96 lg:w-[400px]"
                  [placeholder]="'eclass.tarefa.pesquisar-aluno' | translate"
                />
                <svg-icon
                  class="absolute left-4 w-6 text-modules-eclass-500"
                  [src]="'/assets/icons/icon-search.svg'"
                ></svg-icon>
              </div>
            </div>
            @if (activitySelected$ | async; as activity) {
              <div class="relative flex w-full md:h-full md:grow">
                <div class="md:h-[calc(100dvh-260px)] h-[30vh] w-full overflow-y-auto px-2 md:px-4 lg:px-8">
                  <table
                    [formGroup]="form"
                    class="table shadow-inner md:shadow-none w-full border-separate border-spacing-y-1"
                  >
                    <thead>
                      <tr
                        class="bg-transparent text-modules-eclass-500 [&>th:first-child]:rounded-l-lg [&>th:last-child]:rounded-r-lg [&>th]:whitespace-nowrap [&>th]:px-3 [&>th]:py-1"
                      >
                        <th translate>geral.aluno</th>
                        <th translate>eclass.tarefa.cumprida</th>
                        @if (!!activity.evaluative) {
                          <th translate>eclass.nota</th>
                        }
                        <th class="hidden md:flex" translate>eclass.tarefa.observacoes</th>
                      </tr>
                    </thead>

                    <tbody
                      formArrayName="students"
                      class="&>tr>td]:px-3 [&>tr:nth-child(even)]:bg-modules-eclass-100 [&>tr:nth-child(odd)]:bg-base-gray-light-400 [&>tr>td:first-child]:rounded-l-lg [&>tr>td:last-child]:rounded-r-lg [&>tr>td]:cursor-default [&>tr>td]:py-2 [&>tr>td]:md:py-4 [&>tr>td]:text-center"
                    >
                      @if (studentFilterState | filter: searchCtrl.value : ['name']; as students) {
                        @if (!(students | isEmpty)) {
                          @for (student of students; track student.id) {
                            <tr
                              class="h-[56px] md:h-[66px]"
                              [ngClass]="{
                                'active bg-modules-eclass-500! text-white  transition-all duration-200':
                                  selectStudent === student.id,
                              }"
                              (click)="onStudentSelect(student)"
                              [formGroup]="getStudentFormGroup(student.id)"
                            >
                              <td>
                                <div class="flex h-10 w-full items-center justify-start gap-2 md:gap-4 pl-4">
                                  <div
                                    [ngClass]="studentState(student.group_by).border"
                                    class="relative flex items-center justify-center rounded-full md:border-2"
                                  >
                                    <span
                                      class="border hidden md:flex w-max rounded-full! bg-white/80 shadow-sm shadow-black/40"
                                    >
                                      <app-user-photo class="h-10 w-10" [src]="student.photo"></app-user-photo>
                                    </span>
                                    <div
                                      class="md:absolute left-8 top-0 flex w-fit items-center justify-center rounded-full bg-white"
                                    >
                                      <svg-icon
                                        [ngClass]="studentState(student.group_by).text"
                                        class="w-6"
                                        [src]="'/assets/icons/icon-checked-circle.svg'"
                                      ></svg-icon>
                                    </div>
                                  </div>
                                  <div class="flex flex-col items-start pl-0 md:pl-2">
                                    <span
                                      class="whitespace-nowrap w-34 md:w-full truncate font-goldplay text-[14px] font-medium text-base-gray-light-950 group-active:text-white"
                                      >{{ student.name }}</span
                                    >
                                  </div>
                                </div>
                              </td>
                              <td [ngClass]="{ 'pr-3 rounded-r-xl md:rounded-none md:pr-0': !activity.evaluative }">
                                <div class="flex flex-col items-center">
                                  <app-switch
                                    colorTrue="bg-base-mantis-500"
                                    [checked]="!!student.concluded"
                                    formControlName="concluded"
                                    (changeStatus)="onSwitchChange(student, $event)"
                                  ></app-switch>
                                  @if (!!student.concluded) {
                                    <label
                                      class="text-base font-normal text-base-gray-light-800 group-active:text-white"
                                      >{{ studentState(student.concluded_group).label }}</label
                                    >
                                  }
                                </div>
                              </td>
                              @if (!!activity.evaluative) {
                                <td class="pr-3 rounded-r-xl md:rounded-none md:pr-0">
                                  <app-modal-review-score
                                    [activity]="activity"
                                    formControlName="score"
                                    (blur)="onBlur(student)"
                                  ></app-modal-review-score>
                                </td>
                              }
                              <td>
                                <div class="hidden md:flex items-center justify-center">
                                  <svg-icon
                                    (click)="onStudentSelect(student)"
                                    class="w-8 cursor-pointer text-modules-eclass-500 group-active:text-white lg:w-10"
                                    [src]="'/assets/icons/icon-comment-dots.svg'"
                                  ></svg-icon>
                                </div>
                              </td>
                            </tr>
                          }
                        } @else {
                          <tr class="h-[200px]">
                            <td colspan="4">
                              <app-jumbotron translate> geral.filtro-vazio </app-jumbotron>
                            </td>
                          </tr>
                        }
                      }
                    </tbody>
                  </table>
                  <div
                    class="hidden md:absolute left-0 bottom-0 z-10 md:flex h-fit w-full items-center justify-end px-2 py-2 bg-base-gray-light-50 md:px-4 md:py-4 shadow-up shadow-base-gray-light-500"
                  >
                    @if ({ submitted: submitted$ | async }; as action) {
                      <button
                        app-outline-button
                        class="h-10 gap-3 rounded-lg bg-theme-500 text-theme-contrast"
                        type="button"
                        [disabled]="true"
                      >
                        @if (!action.submitted) {
                          <p>{{ 'eclass.tarefa.alteracoes-salvas' | translate }}</p>
                        }
                        @if (action.submitted) {
                          <app-skeleton class="h-5! w-5! px-4" baseStyle="bg-theme-500"></app-skeleton>
                          {{ 'eclass.tarefa.salvando' | translate }}
                        }
                      </button>
                    }
                  </div>
                </div>
              </div>
              <div
                class="md:hidden bottom-0 z-10 flex h-fit w-full items-center justify-end px-2 py-2 bg-base-gray-light-50 md:px-4 md:py-4 shadow-up shadow-base-gray-light-500"
              >
                @if ({ submitted: submitted$ | async }; as action) {
                  <button
                    app-outline-button
                    class="h-10 gap-3 rounded-lg bg-theme-500 text-theme-contrast"
                    type="button"
                    [disabled]="true"
                  >
                    @if (!action.submitted) {
                      <p>{{ 'eclass.tarefa.alteracoes-salvas' | translate }}</p>
                    }
                    @if (action.submitted) {
                      <app-skeleton class="h-5! w-5! px-4" baseStyle="bg-theme-500"></app-skeleton>
                      {{ 'eclass.tarefa.salvando' | translate }}
                    }
                  </button>
                }
              </div>
            }
          </div>
        </div>
        <!-- fin lista de alumnos -->

        @if (answerStudentSelected$ | async; as answer) {
          <div
            [ngClass]="{ 'md:w-full': expand() }"
            class="md:flex grid grid-rows-2 md:flex-col lg:flex-row h-full overflow-y-scroll w-full md:w-3/5"
          >
            <!-- lista de adjuntos -->
            <div
              [ngClass]="{ 'h-full w-full! row-span-2': (fileView$ | async) == null, hidden: expand() }"
              class="z-20 flex flex-col overflow-y-scroll items-center justify-start bg-base-light-container md:h-1/2 lg:h-full lg:w-1/3"
            >
              <div class="flex w-full flex-col bg-base-gray-light-50 p-2 md:p-5">
                <span class="md:px-5 px-2 text-start font-goldplay text-base text-base-gray-light-800" translate
                  >agenda.anexos</span
                >
                <div class="flex w-full flex-row items-center gap-3">
                  <div class="flex w-full flex-col items-center justify-center">
                    <div
                      app-button
                      #popoverAnswers
                      (click)="onSelectAnswer(popoverAnswers)"
                      class="flex w-full items-center rounded-[2rem]! bg-modules-eclass-100 px-5 py-3"
                    >
                      <div class="flex w-full gap-2 items-center justify-between">
                        <div class="flex items-center justify-center gap-2">
                          <svg-icon
                            class="w-2 text-base-whisper-900"
                            src="assets/icons/icon-arrow-small.svg"
                          ></svg-icon>
                          <p class="font-goldplay text-base font-medium">
                            {{ answer.created_at | date: 'medium' }}
                          </p>
                        </div>
                        <svg-icon class="h-6 w-6" src="assets/icons/icon-arrow-down-fine.svg"></svg-icon>
                      </div>
                    </div>
                  </div>
                  <div
                    class="m-2 flex h-fit w-fit flex-col items-center justify-center rounded-full bg-modules-eclass-100"
                  >
                    <button
                      app-icon-button
                      #buttonResubmissionDate
                      (click)="onOpenResubmissionDatepicker(answer.id, buttonResubmissionDate)"
                      type="button"
                      app-tooltip
                      tooltip="{{ 'agenda.liberar-entrega' | translate }}"
                      class="flex h-12 w-12 items-center justify-center rounded-full border-theme-500"
                    >
                      <svg-icon class="w-6 text-theme-500" src="/assets/icons/icon-clock-reply.svg"></svg-icon>
                    </button>
                  </div>
                </div>
                @if (answer.resubmission_date) {
                  <p>
                    <span class="text-sm font-normal" translate> agenda.liberado-ate </span>
                    <span class="font-semibold">{{ answer.resubmission_date | date: 'dd/MM/yyyy hh:mm' }}</span>
                  </p>
                }
              </div>
              @if (answer?.attachments?.length > 0) {
                <div class="h-fit w-full">
                  <app-modal-review-files
                    class="rounded-lg!"
                    [attachmentIdSelected]="(fileView$ | async)?.id"
                    (select)="onSelectAttachment($event)"
                  ></app-modal-review-files>
                </div>
              }
              <div class="flex w-full h-fit flex-col items-center justify-center md:px-5 md:pb-5">
                <app-modal-review-feedback
                  class="w-full"
                  (fileView)="onOpenFileViewer($event)"
                ></app-modal-review-feedback>
              </div>
            </div>
            <!-- fin lista de adjuntos -->
            @if (hasAttachments(answer)) {
              <!-- visor adjuntos -->
              @if (fileView$ | async; as fileview) {
                <div
                  class="z-30 relative row-span-1 md:relative flex w-full justify-center bg-base-gray-light-900 md:h-1/2 lg:h-full lg:w-2/3"
                  [ngClass]="{ 'h-full row-span-2 grow': expand() }"
                >
                  <div
                    class="m-2 absolute z-30 top-0 right-0 flex h-fit w-fit flex-col items-center justify-center rounded-full bg-modules-eclass-100"
                  >
                    <button
                      (click)="onExpand()"
                      app-icon-button
                      class="flex h-12 w-12 items-center justify-center rounded-full border-theme-500"
                    >
                      @if (expand()) {
                        <svg-icon class="w-6 text-theme-500" src="/assets/icons/icon-collapse.svg"></svg-icon>
                      } @else {
                        <svg-icon class="w-6 text-theme-500" src="/assets/icons/icon-expand.svg"></svg-icon>
                      }
                    </button>
                  </div>

                  <div
                    [ngClass]="{ 'w-full': (answer.attachments?.length ?? 0) === 1 }"
                    class="flex w-[90%]! items-start justify-center overflow-y-auto py-9"
                  >
                    <app-file-viewer class="h-full w-full" [data]="fileview"></app-file-viewer>
                  </div>
                </div>
              } @else {
                <app-jumbotron class="w-full items-center rounded-none!"></app-jumbotron>
              }
            }
            <!-- fin visor adjuntos -->
          </div>
        } @else {
          <app-jumbotron class="w-full h-full row-span-1 grow!">
            <p class="px-4 text-center" translate>eclass.tarefa.concluir-atividade</p>
          </app-jumbotron>
        }
      }
    </div>
  } @else {
    <div class="w-screen h-screen">
      <app-skeleton></app-skeleton>
    </div>
  }
</div>
